export default {
  appTitle: 'Hooshmand Teb',
  panelTitle: 'Hooshmand Teb Management Dashboard',
  copyRight: '@:(branding.appTitle), All rights reserved'
}
